import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './components/Home';
import ClientDetail from './components/ClientDetail';
import Login from './pages/Login';

const DEV = process.env.NODE_ENV === 'development';

function RequireAuth({ children }: { children: React.ReactElement }) {
  if (DEV) return children;
  return localStorage.getItem('token') ? children : <Navigate to="/login" replace />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<RequireAuth><Home /></RequireAuth>} />
        <Route path="/cliente/:id" element={<RequireAuth><ClientDetail /></RequireAuth>} />
      </Routes>
    </Router>
  );
}

export default App;
